import AdministracionRoutes from './administracion';
import SistemaRoutes from './sistema';
import UsuarioRoutes from './usuario';

export default [].concat(
    AdministracionRoutes,
    SistemaRoutes,
    UsuarioRoutes,
);